export default __webpack_public_path__ + "static/media/martKlein.629fa679.jpg";